/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


console.log("✅ custom.js loaded");





// QIKIFY CART DISCOUNT CODE REPLACEMENT
document.addEventListener("DOMContentLoaded", function() {
  function replaceQikifyCode() {
    document.querySelectorAll('discount-title').forEach(el => {
      if (el.textContent.trim() === 'QIKIFY-G7G9HT') {
        el.textContent = 'FREEGIFT';
      }
    });
  }

  // Run once on page load
  replaceQikifyCode();

  // Observe cart for changes (works for AJAX updates)
  const cartObserver = new MutationObserver(replaceQikifyCode);
  const cartElement = document.querySelector('cart-item-discounts');
  if (cartElement) {
    cartObserver.observe(cartElement, { childList: true, subtree: true });
  }
});



// CUSTOM CODE TO ADJUST FILTER HEADINGS ON SHOP PAGES

(function() {
  const headings = [
    'TIES',
    'NECKTIES',
    'BOW TIES',
    'HAIR',
    'HAIRWEAR',
    'PETS',
    'PET ACCESSORIES',
    'MORE'
  ];

  function formatFilterHeadings() {
    document.querySelectorAll('.collection-sidebar__item').forEach(item => {
      const label = item.querySelector('.collection-sidebar__link');
      const input = item.querySelector('input');

      if (!label) return;

      const text = label.textContent.trim().replace(/\s+/g, ' ');

      if (headings.includes(text)) {
        item.classList.add('filter-heading');

        if (input) {
          input.checked = false;
          input.disabled = true;
          input.style.display = 'none';
        }

        label.removeAttribute('for');
        label.style.pointerEvents = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', formatFilterHeadings);

  // Re-apply after Shopify/Venue refreshes filters
  const observer = new MutationObserver(function() {
    formatFilterHeadings();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();







